export interface AppConfig {
  rewardsV2Enabled: boolean;
  /** CWS-1805: super-admin feature flags resolved for the signed-in user's company. */
  features?: Record<string, boolean>;
}

export type RewardRuleServiceType = 'single_wash' | 'membership' | 'prepaid';

export interface RewardRule {
  id: string;
  name: string;
  amount: number;
  service_type: RewardRuleServiceType;
  selected_package_ids: string[];
  items_sold: number;
  theme_color: string;
  is_active: boolean;
  created_at?: string;
  updated_at?: string;
}

export interface CreateRewardRuleRequest {
  name: string;
  amount: number;
  service_type: RewardRuleServiceType;
  selected_package_ids: string[];
  items_sold: number;
  theme_color: string;
}

/** Same body shape as create; used for PUT employee/reward-rules/:id */
export type UpdateRewardRuleRequest = CreateRewardRuleRequest;

export interface OfferedRewardRule {
  id: string;
  name: string;
  items_sold: number;
  amount: number;
  theme_color: string;
  service_type: RewardRuleServiceType;
  amount_won_today: number;
  progress: number | null;
}

export interface OfferedRewardsResponse {
  lifetime_earned: number;
  rules: OfferedRewardRule[];
}

export interface RewardsHistoryColumn {
  rule_id: string;
  name: string;
}

export interface RewardsHistoryByRuleCell {
  count: number;
  amount: number;
}

export interface RewardsHistoryItemV2 {
  date: string;
  total_rewards: number;
  by_rule: Record<string, RewardsHistoryByRuleCell>;
}

export interface RewardsHistoryPagination {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface RewardsHistoryResponse {
  columns: RewardsHistoryColumn[];
  items: RewardsHistoryItemV2[];
  pagination: RewardsHistoryPagination;
}

export interface RewardsHistoryFilters {
  timezone?: string;
  page?: number;
  limit?: number;
  start_date?: string;
  end_date?: string;
}

export interface AdminRewardsSummaryEmployee {
  employee_id: string;
  name: string;
  avatar: string | null;
  emp_id: string | null;
}

export interface AdminRewardsSummaryItem {
  employee: AdminRewardsSummaryEmployee;
  total_rewards: number;
  by_rule: Record<string, RewardsHistoryByRuleCell>;
}

export interface AdminRewardsSummaryResponse {
  columns: RewardsHistoryColumn[];
  items: AdminRewardsSummaryItem[];
  pagination: RewardsHistoryPagination;
}

export interface AdminRewardsSummaryFilters {
  timezone?: string;
  page?: number;
  limit?: number;
  search?: string;
  start_date?: string;
  end_date?: string;
}

export const SERVICE_TYPE_LABELS: Record<RewardRuleServiceType, string> = {
  single_wash: 'single wash',
  membership: 'membership',
  prepaid: 'prepaid',
};
